/* Jasumati motion: scroll reveal for homepage sections.
   Adds .jm-ready to <html> only when IntersectionObserver works and motion is allowed,
   so content is never hidden if this script fails. */
(function () {
  'use strict';
  if (window.__jmMotion) return;
  window.__jmMotion = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;
  if (reduce || design || !('IntersectionObserver' in window)) return;

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var sections = Array.prototype.slice.call(main.querySelectorAll(':scope > .shopify-section'));
    var targets = [];
    sections.forEach(function (s, i) {
      if (i < 2) return;
      if (s.querySelector('.scroll-trigger, sticky-add-cart, .main-product, .product-detail__information, .jsg-modal, [class*="marquee"]')) return;
      if (s.offsetHeight < 40) return;
      s.setAttribute('data-jm-reveal', '');
      targets.push(s);
    });

    var groups = main.querySelectorAll('.jh-hero__trust, .jco-list');
    Array.prototype.forEach.call(groups, function (g) { g.setAttribute('data-jm-stagger', ''); targets.push(g); });

    if (!targets.length) return;
    document.documentElement.classList.add('jm-ready');

    function show(el) {
      el.classList.add('jm-in');
      setTimeout(function () { el.classList.add('jm-done'); }, 900);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        show(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    targets.forEach(function (t) { io.observe(t); });

    // Safety net: anything on screen that the observer missed is shown after 2.5s
    setTimeout(function () {
      targets.forEach(function (t) {
        if (t.classList.contains('jm-in')) return;
        var r = t.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { show(t); io.unobserve(t); }
      });
    }, 2500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
